// extracted by mini-css-extract-plugin
module.exports = {"timeAndDate":"TimeAndDate_timeAndDate__2XJtB","time":"TimeAndDate_time__1y9Jw","date":"TimeAndDate_date__3sDo3"};